import * as React from "react";

// Same host in every tier, as in bouncieweb's config.
export const QUOTE_FORM_URL = "https://forms.bouncie.com/quote";
const QUOTE_FORM_ORIGIN = new URL(QUOTE_FORM_URL).origin;

interface QuoteFormEmbedProps {
  title: string;
  qty?: string | null;
  qid?: string | null;
}

// The hosted form drives the parent over postMessage: it reports its height (so there
// is no nested scrolling) and asks the page to scroll or redirect.
export function QuoteFormEmbed({ title, qty, qid }: QuoteFormEmbedProps) {
  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  React.useEffect(() => {
    function onMessage({ data, source, origin }: MessageEvent) {
      const iframe = iframeRef.current;
      if (!data || typeof data !== "object" || !iframe || source !== iframe.contentWindow) return;

      if (data.type === "setHeight" && typeof data.height === "number") {
        iframe.style.height = `${data.height}px`;
      } else if (data.type === "form-scroll-to") {
        const header = document.querySelector("header")?.getBoundingClientRect();
        const headerOffset = header && header.top <= 0 ? Math.max(header.bottom, 0) : 0;
        const y = Number(data.yWithinFrame ?? data.y) || 0;
        const top = window.scrollY + iframe.getBoundingClientRect().top + y - headerOffset - (Number(data.extraOffset) || 0);
        window.scrollTo({ top, behavior: "smooth" });
      } else if (data.type === "form-redirect" && origin === QUOTE_FORM_ORIGIN && typeof data.url === "string" && /^https:\/\//i.test(data.url)) {
        window.location.href = data.url;
      }
    }
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const params = new URLSearchParams();
  if (qty != null) params.set("qty", qty);
  if (qid != null) params.set("qid", qid);
  const query = params.toString();

  return (
    <iframe
      ref={iframeRef}
      src={query ? `${QUOTE_FORM_URL}?${query}` : QUOTE_FORM_URL}
      title={title}
      scrolling="no"
      className="block min-h-[400px] w-full border-0 bg-white"
    />
  );
}
